import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import increaseImage from '../images/digitalAssociate.png'
import increaseValue from '../images/increaseValue.png'
import opertionImage from '../images/Operations.png'
import investingImage from '../images/investing.png'
import clientImage from '../images/ClientService.png'

function Home() {
  return (
    <div className="home-container">
    {/*------Intelligent associates for your business------*/}
    <div className ="container d-flex align-items-center justify-content-between flex-wrap">
      {/* Left Column */}
      <div className="home-text-header">
        <br/><br/>
        <h2>Intelligent Agents for your business</h2>
        <p>
        Grow your AUM and profitability with end-to-end automation, digital planning, advice, and communication at the household goal level — while making more for your clients with multi-pronged tax optimization.
        </p>
      </div>
      {/*------Intelligent Image------*/}
      {/* Right Column */}
      <div className="home-image">
        <br /><br/>
        <img src={increaseImage} alt="Investment Illustration" />
      </div>
    </div>
    <div className="container d-flex align-items-center justify-content-between flex-wrap">
        {/* Left Column */}
        {/*---Increase Section---*/}
        <div className="home-text-header">
          <div className="feature-card">
          <h3>Increase your AUM</h3>
          <p>Create a better offering using Alternatives and let the TaxAssociate keep more of what you make for your clients using multi-pronged strategies.
          </p>
        </div>
        </div>
        {/*---Reduce Section---*/}        
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Reduce your unit cost</h3>
          <p>Let our digital associates perform tasks, manage personalized models, provide intelligent advice and execute orders from trade to clearing.
          </p>
        </div>
        </div>
        {/*---Improve Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Improve client care</h3>
          <p>Focus on your clients, their households, goals and plans. Let digital associates help you service them at the same level and communicate more effectively. 
          </p>
        </div>
        </div>
        {/*---Demo  Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-200px'}}>
          <div className="home-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
                style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
                Book a Demo
              </Link>
            </div>
          </div>
        </div>
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap " style={{ marginTop: '-100px'}}>
        {/* Right Column */}
        {/*-----Increase Image------*/}
        <div className="home-image">
          <img src={increaseValue} alt="Investment Illustration" />
        </div>

        {/* Left Column */}
        {/*------Increase the value of your business------*/}
        <div className="home-text-header">
          <h2>Increase the value of your business</h2>
          <p>
          Our <n style={{fontSize: '1rem',color: '#FFA302'}}>Digital</n><i>Associates</i> are intelligent partners who automate the daily operations that weigh down your team. 
          From client service to portfolio management to compliance, <n style={{fontSize: '1rem',color: '#FFA302'}}>Digital</n><i>Associates</i> execute end-to-end processes 
          so your staff can shift focus from administration to acceleration - spending more time growing client relationships, 
          winning new business, and scaling the practice.
          </p>
        </div>
        {/*---2x Section---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        <div className="home-text-header">
          <div className="feature-card">
          <h3>2x more clients</h3>
          <p>per advisor</p>
        </div>
        </div>
        {/*---60% Section---*/}  
        <div className="home-text-header">
        <div className="feature-card">
          <h3>60% reduction</h3>
          <p>in operational expenses</p>
        </div>
        </div>
        {/*---1% Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>1% tax alpha</h3>
          <p>for your clients</p>
        </div>
        </div>
        {/*---Demo  Button---*/}
          <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-250px'}}>
            <div className="home-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
          <Link to="/BookDemo" className="btn btn-outline-secondary me-2" 
            style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
            Book a Demo
          </Link>
          </div>
          </div>
        </div>
        </div>
        </div>

        
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
        {/* Left Column */}
        {/*------Client Servicing, Their Way------*/}
        <div className="home-text-header">
          <h2>Client Servicing, Their Way</h2>
          <p>
            Look after your clients and their goals in a personal and timely manner – <n style={{fontSize: '1rem',color: '#FFA302'}}>Digital</n><i>Associates</i> offers digital 
            planning, advice, and communication, as well as advanced tax optimization that lets them keep more.
          </p>
        </div>

        {/* Right Column */}
        {/*---Client Image---*/}
        <div className="home-image">
          <img src={clientImage} alt="Investment Illustration" />
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        {/* Left Column */}
        {/*---Focus Section---*/}
        <div className="home-text-header">
          <div className="feature-card">
          <h3>Focus on your clients and <br/>goals</h3>
          <p>
            Shift the conversation from performance to realizing their goals through embedded investment planning, 
            automatically connected to execution.
          </p>
        </div>
        </div>
        {/*---Service Section---*/}        
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Service at the household goal level</h3>
          <p>
            Speak to your clients about their needs; digital advice bridges the gap between the household goals and the 
            accounts in an optimal, tax-efficient manner.
          </p>
        </div>
        </div>
        {/*---Communicate Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Communicate in a personalized manner</h3>
          <p>
            Reach your clients with Deeply Personalized and Perfectly Timed communication to enhance engagement for every 
            client while reducing effort and ensuring compliance.
          </p>
        </div>
        </div>
        {/*---Demo Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="home-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>
        </div>
        </div>

      {/*------Operation, Completely Digital------*/}
      <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{marginTop: '-150px'}}>
        {/* Left Column */}
        {/*------Operations Image------*/}
        <div className="home-image">
          <img src={opertionImage} alt="Investment Illustration" />
        </div>

        {/* Right  Column */}
        <div className="home-text-header">
        <br/><br/>
          <h2>Operations, Completely Digital</h2>
          <p>Increase your operational efficiency with streamlined workflows that enforce your policies – <n style={{fontSize: '1rem',color: '#FFA302'}}>Digital</n><i>Associates</i> eliminate manual tasks and spreadsheets by using Augmented Intelligence to bridge the gap between your client's needs and back-office transactions.
          </p>
        </div>
        </div>
        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        {/*---Reduce Section---*/}
        <div className="home-text-header">
          <div className="feature-card">
          <h3>Automate and reduce manual effort</h3>
          <p>Digital automation dramatically reduces the manual effort, freeing your team to focus on clients and prospects.</p>
          </div>
        </div>
        {/*---Enforce Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Enforce regulations and your policies</h3>
          <p>Policy enforcement in real-time ensures proactive compliance, drastically reducing non-compliant events.</p>
        </div>
        </div>
        {/*---Support Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Support your business with a single provider</h3>
          <p>
            One platform offers automation and advanced features for every aspect of your business, eliminating the 
            complexities of managing multiple systems.
          </p>
        </div>
        </div>
        {/*---Demo Button---*/} 
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="home-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>        
          </div>
          </div>

          <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-100px'}}>
        {/*------Investing, Effortlessly Personalized-----*/}
        {/* Left Column */}
        <div className="home-text-header">
          <h2>Investing, Effortlessly Personalized</h2>
          <p>
          Provide a sophisticated, personalized service for each client. <n style={{fontSize: '1rem',color: '#FFA302'}}>Digital</n><i>Associates</i> maintains customized versions while adding tax optimization, support for alternatives, digital transition, and more. 
          </p>
        </div>

        {/* Right Column */}
        {/*---Investing Image---*/}
        <div className="home-image">
          <img src={investingImage} alt="Investment Illustration" />
        </div>
        </div> 
        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        {/* Left Column */}
        {/*---Your clients Section---*/}
        <div className="home-text-header">
          <div className="feature-card">
          <h3>Your clients keep more of what they've earned </h3>
          <p>
            Elevate tax minimization beyond harvesting with sophisticated asset location and portfolio transition, 
            delivering a much greater tax alpha.
          </p>
          </div>
        </div>
        {/*---Include Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Include alternatives to increase returns and mitigate risk</h3>
          <p>
            Create better client results and greater diversification with advanced support for alternative assets, multiple 
            currencies, and separate managers.
          </p>
          </div>
        </div>
        {/*---Offer Section---*/}
        <div className="home-text-header">
        <div className="feature-card">
          <h3>Offer tailored portfolios to your clients</h3>
          <p>
            Personalize your clients' investment experience within suitability restrictions, creating thousands of 
            personalized portfolios maintained through a few standard ones. 
          </p>
        </div>
        </div>
        </div>
        {/*---Demo Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="home-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>
        {/*------Learn How------*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap"  style={{ marginTop: '-100px', backgroundColor: '#EDDBD0', borderRadius:'25px'}}>
        <div className="home-text-header" style={{ textAlign: 'center'}}>
          <br/><br/>
          <h1>Learn how intelligent automation can help your business</h1>
          <Link to="/BookDemo" className="btn btn-outline-secondary me-2" style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
          Book a Demo
          </Link>
        </div>
        </div>  
      {/*------Site Footer------*/}
      <footer className="site-footer">
        <div className="container text-center">
          <p>&copy; {new Date().getFullYear()} Cloudvisor DigitalAssociate. All rights reserved.</p>
        </div>
      </footer>
  </div>

  );
}

export default Home;